import { withDirectives as _withDirectives, resolveDirective as _resolveDirective, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue";
import "core-js/modules/es.array.push.js";
import "./payDialog.less";
import { ElMessage } from "element-plus";
import { userStore } from "@/stores/modules/user";
import QRCode from "qrcodejs2-fix";
import { fetchTemplatePrice, addCreateOrder, checkPayState } from "@/api/exibition";
import { useCoupons } from "@/api/coupon";
import { dataCollect } from "@/api/me";
let router;
const couponCode = ref("");
const dialogBody = defineComponent({
  props: ["priceList"],
  setup(props, {
    slots,
    emit
  }) {
    const selectSet = ref("");
    const couponTypeList = ref([]);
    watch(() => props.priceList, val => {
      if (val.length) {
        selectSet.value = val[0].id;
        handleChange();
      }
    });
    const set = computed(() => {
      return props.priceList.find(x => {
        return x.id == selectSet.value;
      });
    });
    const getCouponsData = () => {
      const user = userStore();
      useCoupons({
        userId: user.userInfo.userId
      }).then(res => {
        couponTypeList.value = res.data;
      });
    };
    getCouponsData();
    const discount = ref("");
    const handleChange = () => {
      emit("setchange", set.value);
    };
    return () => _createVNode("div", null, [_createVNode(_resolveComponent("el-row"), {
      "class": "exbition-details__price__title"
    }, {
      default: () => [_createVNode(_resolveComponent("el-col"), {
        "span": 7
      }, {
        default: () => [_createVNode("p", null, [_createTextVNode("\u9009\u62E9\u5957\u9910")])]
      }), _createVNode(_resolveComponent("el-col"), {
        "span": 11
      }, {
        default: () => [_createVNode("p", null, [_createTextVNode("\u9009\u62E9\u4F18\u60E0\u65B9\u6848")])]
      }), _createVNode(_resolveComponent("el-col"), {
        "span": 6
      }, {
        default: () => [_createVNode("p", null, [_createTextVNode("\u5E94\u4ED8\u6B3E")])]
      })]
    }), _createVNode(_resolveComponent("el-row"), null, {
      default: () => [_createVNode(_resolveComponent("el-col"), {
        "span": 7
      }, {
        default: () => [_createVNode(_resolveComponent("el-radio-group"), {
          "modelValue": selectSet.value,
          "onUpdate:modelValue": $event => selectSet.value = $event,
          "class": "exbition-details__price__radio vh",
          "border": true,
          "onChange": handleChange
        }, {
          default: () => [props.priceList?.map(item => {
            return _createVNode(_resolveComponent("el-radio"), {
              "label": item.id,
              "border": true
            }, {
              default: () => [_createVNode("span", {
                "class": "set-price__text",
                "style": "--text:" + item.price.toString().length + "px"
              }, [_createTextVNode("\uFFE5"), item.price]), _createVNode("span", {
                "class": "set-time__text"
              }, [_createTextVNode("/"), item.serviceLife, _createTextVNode("\u4E2A\u6708")])]
            });
          })]
        })]
      }), _createVNode(_resolveComponent("el-col"), {
        "span": 11,
        "class": "el-dialog__body__select flex-column"
      }, {
        default: () => [couponTypeList.value.length > 0 ? _createVNode(_resolveComponent("el-select"), {
          "modelValue": couponCode.value,
          "onUpdate:modelValue": $event => couponCode.value = $event,
          "placeholder": "请选择优惠券",
          "size": "large"
        }, {
          default: () => [couponTypeList.value?.map(item => {
            return _createVNode(_resolveComponent("el-option"), {
              "label": item.name,
              "value": item.couponsCode
            }, null);
          })]
        }) : "暂无优惠券"]
      }), _createVNode(_resolveComponent("el-col"), {
        "span": 6,
        "class": "el-dialog__body__sum vc"
      }, {
        default: () => [set.value && _createVNode("span", {
          "class": "el-dialog__body__sum__price"
        }, ["￥" + parseFloat(set.value?.price).toFixed(2)])]
      })]
    })]);
  }
});
const jump = (router, result) => {
  switch (result.value.sourceType) {
    case 1:
      router.push({
        path: "/tree/" + result.value.id,
        query: {
          edit: "true"
        }
      });
      break;
    case 2:
      router.push({
        path: "/micro-ieds/tenant/" + result.value.id,
        query: {
          exhibitionId: result.value.id
        }
      });
      break;
    case 5:
      window.open(`${process.env.VUE_APP_DESIGNER_ADDRESS}/editor?id=${result.value.id}&token=${userStore().userInfo.token}`);
      router.push("/workplace/history");
      break;
    default:
      router.push({
        path: "/micro-ieds/tenant/" + result.value.id,
        query: {
          exhibitionId: result.value.id
        }
      });
      break;
  }
};
export const payDialog = defineComponent({
  name: "exbitionPayDialog",
  components: {
    dialogBody
  },
  props: ["show", "id", "payFlag", "templateId", "exbitionId", "relevanceUserId"],
  emits: {
    close: () => true,
    pay: data => true
  },
  setup(props, {
    slots,
    emit
  }) {
    router = useRouter();
    const templateId = toRef(props.templateId);
    const loading = ref(false);
    const payStep = ref(1);
    const result = ref();
    const timer = ref();
    const orderInfo = ref();
    let timmer;
    const handleClose = () => {
      clearInterval(timmer);
      stop();
      emit("close");
    };
    const countDown = ref(3);
    const countDownTimer = () => {
      timmer = setInterval(() => {
        if (countDown.value > 0) {
          countDown.value--;
        } else {
          clearInterval(timmer);
          jump(router, result);
        }
      }, 1000);
    };
    const selectSet = ref();
    const priceList = ref([]);
    const qrCodeRef = ref(null);
    const payAmount = ref(0);
    const fetchTemplate = () => {
      loading.value = true;
      fetchTemplatePrice({
        templateId: templateId.value
      }).then(({
        data
      }) => {
        priceList.value = data;
      }).finally(() => {
        loading.value = false;
      });
    };
    fetchTemplate();
    const orderFuc = option => {
      addCreateOrder({
        ...option,
        relevanceUserId: props.relevanceUserId
      }, {
        loading
      }).then(res => {
        orderInfo.value = res.data;
        payAmount.value = Number(res.data.totalFee || 0) * 100;
        if (res.data.isPay == 1) {
          payStep.value = 3;
          result.value = res.data;
          countDownTimer();
          stop();
        } else {
          nextTick(() => {
            const qrCode = new QRCode(document.getElementById("qrCodeBox"), {
              text: orderInfo.value?.codeUrl,
              width: 128,
              height: 128
            });
          });
          timer.value = window.setInterval(() => {
            setTimeout(fetchBillState);
          }, 1000);
        }
      });
    };
    const fetchBillState = () => {
      checkPayState({
        outTradeNo: orderInfo.value.outTradeNo
      }).then(res => {
        if (res.data.tradeState == "SUCCESS") {
          //订单支付成功埋点
          dataCollect({
            fieldType: [19],
            payAmount: payAmount.value
          });
          payStep.value = 3;
          result.value = res.data;
          countDownTimer();
          stop();
        }
      });
    };
    const stop = () => {
      clearInterval(timer.value);
      timer.value = null;
    };
    function scanCode() {
      return _withDirectives(_createVNode("div", {
        "class": "code-body"
      }, [_createVNode("div", {
        "class": "code-content"
      }, [_createVNode("div", {
        "ref": "qrCodeRef",
        "id": "qrCodeBox",
        "class": "code-img"
      }, null), _createVNode("span", null, [_createTextVNode("\u5FAE\u4FE1\u652F\u4ED8")])])]), [[_resolveDirective("loading"), loading.value]]);
    }
    function finishBody() {
      const handleClick = () => {
        clearInterval(timmer);
        jump(router, result);
      };
      return _withDirectives(_createVNode("div", {
        "class": "el-dialog__body__div-finish"
      }, [_createVNode(_resolveComponent("el-icon"), null, {
        default: () => [_createVNode(_resolveComponent("success-filled"), null, null)]
      }), _createVNode("div", {
        "style": "font-size:20px"
      }, [_createTextVNode("\u652F\u4ED8\u6210\u529F")]), _createVNode("p", {
        "class": "el-dialog__body-finish__countdown"
      }, [_createVNode("span", null, [countDown.value + "s后将跳到展项编辑页面"])]), _createVNode(_resolveComponent("el-button"), {
        "type": "primary",
        "onClick": handleClick
      }, {
        default: () => [_createTextVNode("\u5B8C\u6210")]
      })]), [[_resolveDirective("loading"), loading.value]]);
    }
    const handleSummit = () => {
      if (!selectSet.value?.id) {
        ElMessage.warning("请先选择套餐");
        return;
      }
      if (!agree.value) {
        ElMessage.warning("请先同意相关条款");
        return;
      }
      let OrderType;
      (function (OrderType) {
        OrderType[OrderType["buy"] = 1] = "buy";
        OrderType[OrderType["clone"] = 2] = "clone";
      })(OrderType || (OrderType = {}));
      payStep.value = payStep.value << 1;
      if (props.payFlag === "buy") {
        orderFuc({
          priceId: selectSet.value.id,
          templateId: templateId.value,
          couponsCode: couponCode.value,
          operationType: OrderType.buy
        });
      } else if (props.payFlag === "clone") {
        orderFuc({
          priceId: selectSet.value.id,
          templateId: props.exbitionId,
          couponsCode: couponCode.value,
          operationType: OrderType.clone
        });
        // cloneExbiton({
        //   copyItemsId: props.exbitionId,
        //   priceId: selectSet.value.id,
        // })
        //   .then(({ data }) => {
        //     result.value = data;
        //     payStep.value = payStep.value << 1;
        //     countDownTimer();
        //   })
        //   .finally(() => {
        //     loading.value = false;
        //   });
      }
    };

    const handleSetChange = val => {
      selectSet.value = val;
    };
    const agree = ref();
    return () => _createVNode(_resolveComponent("el-dialog"), {
      "modelValue": props.show,
      "title": "购买套餐",
      "width": "52%",
      "before-close": handleClose,
      "id": "exbitionPayDialog"
    }, {
      [payStep.value == 1 ? "footer" : ""]: payStep.value == 1 ? () => [_createVNode(_resolveComponent("el-checkbox"), {
        "class": "exbitionPayDialog__footer__agreement vc",
        "modelValue": agree.value,
        "onUpdate:modelValue": $event => agree.value = $event,
        "label": "1"
      }, {
        default: () => [_createTextVNode("\u652F\u4ED8\u8868\u793A\u60A8\u5DF2\u9605\u8BFB\u5E76\u540C\u610F "), _createVNode(_resolveComponent("el-link"), null, {
          default: () => [_createTextVNode("\u300A\u670D\u52A1\u6761\u6B3E\u300B")]
        })]
      }), _createVNode("div", null, [_createVNode(_resolveComponent("el-button"), {
        "class": "exbitionPayDialog__footer__paybutton",
        "type": "default",
        "onClick": () => {
          emit("close");
        }
      }, {
        default: () => [_createTextVNode("\u53D6 \u6D88")]
      }), _createVNode(_resolveComponent("el-button"), {
        "class": "exbitionPayDialog__footer__paybutton",
        "onClick": handleSummit,
        "type": "primary",
        "disabled": loading.value
      }, {
        default: () => [_createTextVNode("\u7ACB\u5373\u652F\u4ED8")]
      })])] : null,
      default: () => {
        switch (payStep.value) {
          case 1:
            return _withDirectives(_createVNode(_resolveComponent("dialog-body"), {
              "priceList": priceList.value,
              "onSetchange": handleSetChange
            }, null), [[_resolveDirective("loading"), loading.value]]);
          case 2:
            return scanCode();
          case 3:
            return finishBody();
          default:
            break;
        }
      }
    });
  }
});
export const usePay = () => {
  const pay = ref(false);
  const paydialog = payDialog;
  const payFlag = ref("buy");
  const templateId = ref("");
  const exbitionId = ref("");
  return {
    pay,
    paydialog,
    payFlag,
    templateId,
    exbitionId
  };
};